import { render } from "./ClickToEditComponent.vue?vue&type=template&id=2fa012db"
import script from "./ClickToEditComponent.vue?vue&type=script&lang=js"
export * from "./ClickToEditComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__